import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, realTimeBaseURL } from '../../../../Containers/Config/index.js';
import { GET_GOLF_COURSE_FORMATS, GET_GOLF_COURSE_FORMATS_SUCCESS, GET_GOLF_COURSE_FORMATS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* getGolfCourseFormats({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${realTimeBaseURL}/admin/golfcourse-formats`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageIndex: payload?.urlParam?.pageIndex,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_GOLF_COURSE_FORMATS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GOLF_COURSE_FORMATS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GOLF_COURSE_FORMATS_ERROR, payload: error });
  }
}

export function* watchGetGolfCourseFormats() {
  yield takeEvery(GET_GOLF_COURSE_FORMATS, getGolfCourseFormats);
}

function* getGolfCourseFormatsSaga() {
  yield all([fork(watchGetGolfCourseFormats)]);
}

export default getGolfCourseFormatsSaga;
